import { render, staticRenderFns } from "./SiblingsIncomeRow.vue?vue&type=template&id=c953ab8c&"
import script from "./SiblingsIncomeRow.vue?vue&type=script&lang=js&"
export * from "./SiblingsIncomeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports